
import { __ } from 'bits/intl'
import { Component, Prop, Vue } from 'bits/vue'
import OzIconButton, { OzIconButtonColorScheme, OzIconButtonHrefMode } from 'library/v4/components/OzIconButton.vue'

@Component({ components: { OzIconButton } })
export default class OzCloseButton extends Vue {
  ColorScheme = OzIconButtonColorScheme

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * See `OzBaseButton`.
   */
  @Prop({ default: OzIconButtonHrefMode.Default }) hrefMode!: OzIconButtonHrefMode

  /**
   * Button label.
   */
  @Prop({ default: __('Close') }) label!: string
}

export { OzIconButtonHrefMode as OzCloseButtonHrefMode }
